import {
  ActionReducerMapBuilder,
  createAction,
  createReducer,
  PayloadAction,
} from "@reduxjs/toolkit";
import { DefaultDashboardsState, DashboardsState } from "../state/stateItems";
import { TDashboardItem } from "@/data/types";
import { getAllDashboardsAsync, getDashboardByIdAsync } from "../actions";

const handleGetAllDashboardsAsync = (
  state: DashboardsState,
  action: PayloadAction<{ items: TDashboardItem[] }>
) => {
  if (!action?.payload) {
    return state;
  }

  const { items } = action.payload;

  state.items = items;
};

const handleGetDashboardByIdAsync = (
  state: DashboardsState,
  action: PayloadAction<TDashboardItem>
) => {
  if (!action?.payload) {
    return state;
  }

  const dashboard = action.payload;

  state.currentDashboard = dashboard;
};

const reducerBuilder = (builder: ActionReducerMapBuilder<DashboardsState>) => {
  builder.addCase(getAllDashboardsAsync.fulfilled.type, handleGetAllDashboardsAsync);
  builder.addCase(getDashboardByIdAsync.fulfilled.type, handleGetDashboardByIdAsync);
};

export default createReducer(DefaultDashboardsState, reducerBuilder);